import { ForwardRefExoticComponent } from "react";
import {
    ChatIcon,
    CommentIcon,
    GroupedBarChartIcon,
    LogOutIcon,
    NewGridItemIcon,
    PersonIcon,
    ShopIcon,
    FlowBranchIcon,
    CreditCardIcon,
    TruckIcon
} from "evergreen-ui";
import { FMS_CHAT_GROUP, SELF_SERVE_ADMIN_GROUP } from "../rampart/RampartUtils";

export type NavigationTab = {
    name: string,
    to?: string,
    icon: ForwardRefExoticComponent<any>,
    showNewBadge?: boolean,
    // Rampart groups required to SEE this tab. Omit for tabs visible to every
    // authenticated user (still subject to client-type routing). Keep this in
    // sync with each page's own RampartAuthorized gate so the nav never offers a
    // tab that only leads to a blocked page.
    requiredGroups?: string[],
};

export const tabs: {top: NavigationTab[], bottom: NavigationTab[]} = {
    top: [
        {
            name: "Products",
            to: "/products",
            icon: NewGridItemIcon,
            requiredGroups: [SELF_SERVE_ADMIN_GROUP],
        },
        {
            name: "Messages",
            to: "/messages",
            icon: ChatIcon,
            requiredGroups: [SELF_SERVE_ADMIN_GROUP],
        },
        {
            name: "Analytics",
            to: "/analytics",
            icon: GroupedBarChartIcon,
        },
        {
            name: "Payouts",
            to: "/payouts",
            icon: CreditCardIcon,
        },
        {
            name: "Stores",
            to: "/stores",
            icon: ShopIcon,
        },
        {
            name: "Modifiers",
            to: "/cost-payout-modifiers",
            icon: FlowBranchIcon,
            requiredGroups: [SELF_SERVE_ADMIN_GROUP],
        },
        {
            name: "Shipping",
            to: "/shipping-timelines",
            icon: TruckIcon,
            requiredGroups: [SELF_SERVE_ADMIN_GROUP],
        },
        {
            name: "Chat",
            to: "/chat",
            icon: CommentIcon,
            requiredGroups: [FMS_CHAT_GROUP],
        }
    ],
    bottom: [
        {
            name: "Settings",
            to: "/settings",
            icon: PersonIcon,
        },
        {
            name: "Logout",
            to: "/logout",
            icon: LogOutIcon,
        }
    ],
};
